export default {
  meta: {
    title: '点位管理',
    url: '/locxx/pointmng',
    parentPath: ['/locxx'],
    breadcrumbs: {
      path: ['/locxx/pointmng'],
      name: ['点位管理'],
    },
  },
};
